import Vue from 'vue'
import Router from 'vue-router'
import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/components/containers/DefaultContainer')

const ViewStaffDashboard = () => import('./staff/dashboard')
const ViewStaffConfiguration = () => import('./staff/configuration')

Vue.use(Router)

// reference (access.view_reference / m_modules_permissions.reference) ->
// nombre de ruta. Fuente única, ver router/viewsRegistry.js.
const VIEWS = {
  dashboard: 'PaymentsStaffDashboard',
  configuration: 'PaymentsStaffConfigurations',
}

const router =
  [
    {
      path: '/st/payments',
      component: DefaultContainer,
      children: [
        {
          path: '',
          name: VIEWS.dashboard,
          component: ViewStaffDashboard,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Pagos Electrónicos',
          }
        },
        {
          path: 'configurations',
          name: VIEWS.configuration,
          component: ViewStaffConfiguration,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Configuraciones de Billeteras',
          }
        },        
      ]
    },

    {
      path: '/cu/payments',
      component: DefaultContainer,
      children: [

      ]
    },

    {
      path: '/su/payments',
      component: DefaultContainer,
      children: [

      ]
    },
  ]

export default router
export { VIEWS }
